// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2VQ0K","title":"FrontImage_title__3xD6z"};